import { AccountDashboardDocument, useCustomerQuery, useCustomerSession } from "@graphcommerce/magento-customer";
import { Hidden } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";
import { useContext } from "react";
import { ModalContext } from "../../../context/context";
import AuthForms from "../../AuthForms";
import IconUserMale from "../../icons/IconUser_male";

// eslint-disable-next-line import/no-default-export
export default function ProfileIcon() {
  const { loggedIn, valid } = useCustomerSession();
  const dashboard = useCustomerQuery(AccountDashboardDocument, {
    fetchPolicy: 'cache-and-network',
  });

  const useModal = useContext(ModalContext);
  const router = useRouter();
  return (

    // eslint-disable-next-line no-script-url
    <Link href="javascript:void(0)" onClick={async () => {
      if (loggedIn && valid) {
        await router.push('/account')
      } else if (useModal?.set) {
        useModal?.set({
          content: <AuthForms activeForm='login' />,
          open: true, title: '', position: 'center', width: 'max-w-sm'
        })
      }
    }}>
      <Hidden mdDown>
        <div className="flex flex-row w-[130px] h-[40px] border border-light-200 rounded-md p-[5px] text-sm items-center align-middle">
          <IconUserMale width={32} height={32} className="text-light-400" />
          {loggedIn ?
            "ورود / عضویت"
            :
            dashboard.data?.customer?.firstname ? `${dashboard.data?.customer?.firstname} ${dashboard.data?.customer?.lastname}` : "ورود / عضویت"}
        </div>
      </Hidden>
      <Hidden mdUp>
        <IconUserMale width={32} height={32} className="text-black" />

      </Hidden>
    </Link>

  )
}


